import cx from 'classnames';
import {
    COUNSELLING_ALL_TOPICS, COUNSELLING_ARCHIVED_TOPICS,
    COUNSELLING_NEWEST_RESPONSES,
    COUNSELLING_OTHER_TOPICS,
    COUNSELLING_TOPICS_I_AM_FOLLOWING,
    TOPIC_MODERATOR,
} from 'mk/autogenerated/translations/CounsellingsHome.9623a0066363622ab69c8d5f09bc1e2c'
import { isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { Props } from 'mk2/apps/counsellings/containers/CounsellingsHome/CounsellingsHomePage';
import { counsellingsTopicUrl } from 'mk2/apps/counsellings/urls';
import Feed from 'mk2/apps/forum/components/Feed';
import { COUNSELLING_CATEGORY_ID } from 'mk2/apps/forum/constants';
import { PostEntity } from 'mk2/apps/forum/schemas';
import ListItem from 'mk2/components/ListItem';
import { ListItemIcon } from 'mk2/components/ListItemIcon';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import styles from './CounsellingsHome.mscss';

class CounsellingsHome extends React.Component<Props> {
    public shouldComponentUpdate(n: Props) {
        const p = this.props;

        return (
            p.posts !== n.posts ||
            p.after !== n.after ||
            p.loadingState !== n.loadingState ||
            p.complaintsStatistics !== n.complaintsStatistics
        );
    }

    public render() {
        const {
            followingTopics,
            requestUser,
            complaintsStatisticsPerTopic,
            permissions,
            topicStats,
            lastVisitCounts,
            counsellings,
        } = this.props;

        const archivedCounsellings = counsellings.filter((c) => c.isArchived);
        const followingCounsellings = counsellings.filter((c) => Boolean(followingTopics.filter(
            (t) => t.category.id === COUNSELLING_CATEGORY_ID,
        ).find((t) => t.id === c.topic.id))).filter((c) => !archivedCounsellings.includes(c));

        // Filter topics which are already in the previous lists(followingTopicsCounsellings or archivedCounsellings)
        const counsellingsWithoutFollowing = counsellings
            .filter((c) => !followingCounsellings.includes(c))
            .filter((c) => !archivedCounsellings.includes(c));

        return (
            <div>
                {followingCounsellings.length > 0 && (
                    <>
                        <div
                            className={cx(
                                styles.CounsellingsHome__topicsHeading,
                                styles['CounsellingsHome__topicsHeading--first'],
                            )}
                        >
                            <span className={styles.CounsellingsHome__topicsHeading__text}>
                                {COUNSELLING_TOPICS_I_AM_FOLLOWING}
                            </span>
                        </div>

                        {followingCounsellings.map((item, idx) => (
                            <ListItem
                                key={item.id}
                                icon={
                                    (isAuthenticatedAs(requestUser, item.topic.moderators) ||
                                        permissions.indexOf('forum.can_manage_forum') >= 0) &&
                                    complaintsStatisticsPerTopic[item.topic.id] > 0 ? (
                                        <div className={styles.ForumCategories__listItemIcon}>
                                            <ListItemIcon lazy photo={item.counsellorAvatarPhoto} photoVersion="s150x150" />
                                            <span
                                                className={
                                                    styles.ForumCategories__listItemIcon__bullet
                                                }
                                            />
                                        </div>
                                    ) : (
                                        <ListItemIcon lazy photo={item.counsellorAvatarPhoto} photoVersion="s150x150" />
                                    )
                                }
                                isLast={idx === followingCounsellings.length - 1}
                                to={url(counsellingsTopicUrl, { topicSlug: item.topic.slug })}
                                count={lastVisitCounts[item.topic.id] || topicStats[item.topic.id]}
                                asBadge={Boolean(lastVisitCounts[item.topic.id])}
                            >
                                {item.topic.name}
                                {isAuthenticatedAs(requestUser, item.topic.moderators) && (
                                    <span className={styles.ForumCategories__moderatorLabelWrapper}>
                                        <span className={styles.ForumCategories__moderatorLabel}>
                                            {TOPIC_MODERATOR}
                                        </span>
                                    </span>
                                )}
                            </ListItem>
                        ))}
                    </>
                )}

                {counsellingsWithoutFollowing.length > 0 && (
                    <>
                        <div
                            className={cx(
                                styles.CounsellingsHome__topicsHeading,
                                followingCounsellings.length === 0 && styles['CounsellingsHome__topicsHeading--first'],
                            )}
                        >
                            <span className={styles.CounsellingsHome__topicsHeading__text}>
                                {followingCounsellings.length
                                    ? COUNSELLING_OTHER_TOPICS
                                    : COUNSELLING_ALL_TOPICS}
                            </span>
                        </div>

                        {counsellingsWithoutFollowing.map((item, idx) => (
                            this.listItem(item, idx, counsellingsWithoutFollowing)
                        ))}
                    </>
                )}

                {archivedCounsellings.length > 0 && (
                    <>
                        <div
                            className={styles.CounsellingsHome__topicsHeading}
                        >
                            <span className={styles.CounsellingsHome__topicsHeading__text}>
                                {COUNSELLING_ARCHIVED_TOPICS}
                            </span>
                        </div>

                        {archivedCounsellings.map((item, idx) => (
                            this.listItem(item, idx, archivedCounsellings)
                        ))}
                    </>
                )}

                <div className={styles.CounsellingsHome__topicsHeading}>
                    <span className={styles.CounsellingsHome__topicsHeading__text}>
                        {COUNSELLING_NEWEST_RESPONSES}
                    </span>
                </div>

                <div className={styles.CounsellingsHome__feed}>
                    <Feed
                        {...this.props}
                        onPostTopicClickedStoreEvent={this.onPostTopicClickedStoreEvent}
                        showTopic
                        showCreated
                        readonlyPosts={false}
                        inFeed
                    />
                </div>
            </div>
        );
    }

    private onPostTopicClickedStoreEvent = (post: PostEntity) => {
        const { onStoreEvent } = this.props;
        onStoreEvent('forum_category_clicked', {
            slug: post.topic.slug,
            from: 'counsellings_home',
        });
    };

    private listItem = (item, idx, counsellingsInQuestion) => {
        const { requestUser, permissions, complaintsStatisticsPerTopic, topicStats} = this.props;
        return (
            <ListItem
                key={item.id}
                icon={
                    (isAuthenticatedAs(requestUser, item.topic.moderators) ||
                        permissions.indexOf('forum.can_manage_forum') >= 0) &&
                    complaintsStatisticsPerTopic[item.topic.id] > 0 ? (
                        <div className={styles.ForumCategories__listItemIcon}>
                            <ListItemIcon lazy photo={item.counsellorAvatarPhoto} photoVersion="s150x150" />
                            <span
                                className={
                                    styles.ForumCategories__listItemIcon__bullet
                                }
                            />
                        </div>
                    ) : (
                        <ListItemIcon lazy photo={item.counsellorAvatarPhoto} photoVersion="s150x150" />
                    )
                }
                isLast={idx === counsellingsInQuestion.length - 1}
                to={url(counsellingsTopicUrl, { topicSlug: item.topic.slug })}
                count={topicStats[item.topic.id]}
            >
                {item.topic.name}
                {isAuthenticatedAs(requestUser, item.topic.moderators) && (
                    <span className={styles.ForumCategories__moderatorLabelWrapper}>
                        <span className={styles.ForumCategories__moderatorLabel}>
                            {TOPIC_MODERATOR}
                        </span>
                    </span>
                )}
            </ListItem>
        );
    };
}

export default CounsellingsHome;
